import { QuestionLabel } from '@/pages/onboarding/QuestionLabel';
import type { OnboardingStepProps } from '@/pages/onboarding/onboarding.types';
import { SESSION_MODE_OPTIONS, matchOption } from '@/pages/onboarding/onboardingOptions';
import { ChoiceCard, ChoiceCardGroup, Grid, Icon, Stack } from '@careflux/primitives';
import { Controller } from 'react-hook-form';

const SESSION_MODES = SESSION_MODE_OPTIONS.map((option) => option.value);

export const SessionModeField = ({ copy, control }: OnboardingStepProps) => (
  <Controller
    name="sessionMode"
    control={control}
    render={({ field }) => (
      <Stack gap="sm">
        <QuestionLabel id="session-mode-label">{copy.work.modeQuestion}</QuestionLabel>
        <Grid asChild columns={1} gap="sm">
          <ChoiceCardGroup
            aria-labelledby="session-mode-label"
            indicator="radio"
            layout="row"
            value={field.value ?? ''}
            onValueChange={(value) => {
              const next = matchOption(SESSION_MODES, value);
              if (next) field.onChange(next);
            }}
          >
            {SESSION_MODE_OPTIONS.map(({ value, icon }) => (
              <ChoiceCard
                key={value}
                id={`session-mode-${value}`}
                value={value}
                label={copy.work.modes[value].label}
                description={copy.work.modes[value].description}
                icon={<Icon name={icon} />}
              />
            ))}
          </ChoiceCardGroup>
        </Grid>
      </Stack>
    )}
  />
);
